module.exports = __webpack_public_path__ + "img/clerk.1915c94c.png";